<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="filter.searchDate" format="DD-MM-YYYY" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Type</label>
                  <a-select placeholder="Select Type" v-model="filter.type" class="width-full" allowClear>
                    <a-select-option value="As Winner">
                      As Winner
                    </a-select-option>
                    <a-select-option value="As Companion">
                      As Companion
                    </a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot title="Request Guarantee List" createLink="bidBondRequest-create"
        manifestLink="bidBondRequest-manifest-mar" editLink="bidBondRequest-edit" :disabledCreateEditLink="!allowCreate"
        :fileStatus="true" :dataList="datasource" :loading="loading">
        <!-- <div slot="status" slot-scope="data">
          <status :status="data.item.closeStatus" />
        </div> -->
        <!-- <div
          slot="status_file"
          slot-scope="data"
        >
          <div v-if="data.item.statusfile_label"
          class="m-display-flex flex-row space-between"
          >
            <span class="margin-remove">BKM</span>
            <a-tag
              :color="data.item.statusfile_label ? 'green' : ''"
              class="margin-remove"
            >
              {{ data.item.statusfile_value ? data.item.statusfile_value: "-"  }}
            </a-tag>
          </div>
        </div> -->
        <div class="m-display-flex flex-row space-between" slot="status_file" slot-scope="data"
          v-if="data.item.type == 'As Companion'">
          <span class="margin-remove">BKM</span>
          <a-tag :color="data.item.bkm == 'File Have Been Upload' ? 'green' : ''" class="margin-remove">
            {{ data.item.bkm }}

          </a-tag>
        </div>
        <a-button-group slot="actions" slot-scope="item">
          <a-button v-if="item.source.status_besar == 'Revised'" icon="edit"
            @click="handleRevise(item.source)">Revise</a-button>
          <!-- <a-button
            v-if="
              item.source.status_besar == 'Approved' &&
              item.source.can_revisi == '1' &&
              item.source.type == 'FK'
            "
            @click="handleAmandemen(item.source)"
            >Amandemen</a-button
          > -->
        </a-button-group>

      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "bidBondRequest",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
        type: undefined,
      },
      quickSearch: "",
      allowCreate: this.$route.meta.ismarketing,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getListBidBondRequest",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getStatus",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.indexOf(this.quickSearch.toLowerCase()) >=
            0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getDefaultDateFormat
        );
        outputData = _.filter(outputData, (obj) => obj.trans_dt == filter);
      }

      if (this.filter.type) {
        outputData = _.filter(
          outputData,
          (obj) => obj.type && (obj.type.toLowerCase() == this.filter.type.toLowerCase())
        );
      }

      return outputData;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("getListBidBondRequest", { auth: this.getAuth })
        .then((res) => {
          res.forEach((data) => {
            this.rawData.push({
              id: data.bidbond_request_id,
              title: data.no_trans,
              trans_dt: moment(data.trans_dt).format('DD-MM-YYYY'),
              type: data.type,
              keyword:
                data.no_trans.toLowerCase() + " " +
                data.tlc_create.toLowerCase() + " " +
                moment(data.trans_dt).format('DD-MM-YYYY') + " " +
                this.formatCurrency("IDR", data.nominal).toLowerCase() + " " +
                data.type.toLowerCase() + " " +
                data.name_project.toLowerCase(),
              subdesc: [
                data.tlc_create + " | " + moment(data.trans_dt).format('DD-MM-YYYY'),
                data.name_project,
                [
                  {
                    label: "Obligee Name",
                    value: data.obligee_nm,
                  },
                  {
                    label: "Guarantee Category",
                    value: data.kategori_jaminan,
                  },
                  {
                    label: "Nominal",
                    value: this.formatCurrency("IDR", data.nominal),
                  },
                  {
                    label: "Type",
                    value: data.type,
                  },
                  {
                    label: "Guarantee Period",
                    value: moment(data.start_due_dt).format('DD-MM-YYYY') + " ~ "
                      + moment(data.end_due_dt).format('DD-MM-YYYY'),
                  },
                ],
              ],
              //statusfile_label: data.bkm ? "BKM" : null,
              //statusfile_value: data.bkm ? data.bkm : null,
              timeline: data.status_app ? JSON.parse(data.status_app) : [],
              statusfile_label: null,
              statusfile_value: null,
              status_besar: data.status_besar,
              bkm: data.bkm
            });
          });
          this.loading = false;
        });
    },
    handleRevise(item) {
      this.$router.push({
        name: "bidBondRequest-edit-mar",
        params: { id: item.id, type: "revisi" },
      });
    },
    handleAmandemen(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "amandemen" },
      });
    },
  },
};
</script>

<style></style>
